import { ProductSpecificationType } from '../redux/products/types';

const ATTRIBUTE_TRUTHY_VALUES = ['Yes', 'Ja', 'Oui', 'Si', 'Sì'];
export const USB_C_ATTRIBUTE_IDS = {
  hasUsbCPort: 'SATT_USBType-CChargingPort',
  usbChargerIncluded: 'SATT_NetzteilVorhanden',
  usbPowerDeliverySupported: 'SATT_USBPowerDelivery',
  requiredChargingPowerMin: 'SATT_RequiredChargingPower(min)',
  requiredChargingPowerMax: 'SATT_RequiredChargingPower(max)',
} as const;

const findAttributeValue = (specification: ProductSpecificationType, attributeId: string): string | undefined => {
  const attribute = specification.attributes.find((attr) => attr.id === attributeId);
  if (!attribute || attribute.values.length === 0) {
    return undefined;
  }

  return attribute.values[0];
};

export const getUSBCDataFromSpecifications = (
  specifications: ProductSpecificationType[],
): {
  hasUsbCPort: boolean;
  usbChargerIncluded: boolean;
  usbPowerDeliverySupported: boolean;
  requiredChargingPowerMin?: number;
  requiredChargingPowerMax?: number;
} => {
  const usbCSpecification = specifications.find(
    (specification) => specification.attributes.find((attribute) => attribute.id === USB_C_ATTRIBUTE_IDS.hasUsbCPort),
  );

  if (!usbCSpecification) {
    return {
      hasUsbCPort: false,
      usbChargerIncluded: false,
      usbPowerDeliverySupported: false,
    };
  }

  const hasUsbCPort = ATTRIBUTE_TRUTHY_VALUES.includes(
    findAttributeValue(usbCSpecification, USB_C_ATTRIBUTE_IDS.hasUsbCPort),
  );
  const usbChargerIncluded = ATTRIBUTE_TRUTHY_VALUES.includes(
    findAttributeValue(usbCSpecification, USB_C_ATTRIBUTE_IDS.usbChargerIncluded),
  );
  const usbPowerDeliverySupported = ATTRIBUTE_TRUTHY_VALUES.includes(
    findAttributeValue(usbCSpecification, USB_C_ATTRIBUTE_IDS.usbPowerDeliverySupported),
  );

  const requiredChargingPowerMin = findAttributeValue(usbCSpecification, USB_C_ATTRIBUTE_IDS.requiredChargingPowerMin);
  const requiredChargingPowerMax = findAttributeValue(usbCSpecification, USB_C_ATTRIBUTE_IDS.requiredChargingPowerMax);

  return {
    hasUsbCPort,
    usbChargerIncluded,
    usbPowerDeliverySupported,
    requiredChargingPowerMin: requiredChargingPowerMin ? parseFloat(requiredChargingPowerMin) : undefined,
    requiredChargingPowerMax: requiredChargingPowerMax ? parseFloat(requiredChargingPowerMax) : undefined,
  };
};
